module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-active-shine.07f39054.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-active-shine.png
// module id = 3178
// module chunks = 11